var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5DayStreakWhiteShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.996,
    height: 34.619
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4837",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2296",
    d: "M15.576 17.147a4.236 4.236 0 01-.506 2.762.75.75 0 01-.59.375 2.009 2.009 0 01-1.633-.646 2.062 2.062 0 00-.464 1.439 2.43 2.43 0 104.858.039 4.573 4.573 0 00-1.665-3.969z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2297",
    d: "M28.661 2.783a34.919 34.919 0 00-27.326 0A2.288 2.288 0 000 4.883v11.713a18.319 18.319 0 0011.741 17.1l1.6.615a4.618 4.618 0 003.314 0l1.6-.615a18.317 18.317 0 0011.741-17.1V4.883a2.288 2.288 0 00-1.335-2.1zm-8.843 20.592a7.537 7.537 0 01-4.753 1.683q-.293 0-.587-.023a7.858 7.858 0 01-5.231-2.542 7.765 7.765 0 01.217-10.614.751.751 0 011.059-.012l.92.9a9.751 9.751 0 017.5-4.209.75.75 0 01.731 1.037 8.162 8.162 0 00-.552 4.229l.788-.986a.755.755 0 01.586-.281h.245a.747.747 0 01.615.322 7.764 7.764 0 01-1.538 10.496z"
  }))));
}
export default SvgIcon5DayStreakWhiteShield;